<template>
  <BaseButton
    :is-rounded="true"
    type="button"
    :is-small="true"
    :is-default="true"
    @click="$emit('click')"
  >
    Skapa ny överlåtelse som&nbsp;<strong>mäklare</strong>
  </BaseButton>
</template>
<script>
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'CreateNewAsBroker',
  components: {
    BaseButton
  }
};
</script>
